import { useState, useEffect } from 'react';

export default function HomePage() {
  const [timeLeft, setTimeLeft] = useState(120);

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const handleTelegramClick = () => {
    window.open('https://t.me/+V8N7hDHiFN04MjBh', '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex items-center justify-center px-4 py-3">
      <div className="max-w-2xl mx-auto text-center w-full">
        
        {/* Countdown Timer */}
        <div className="bg-red-600 text-white px-3 py-2 rounded-lg mb-3 mx-auto max-w-sm shadow-xl animate-pulse">
          <div className="flex items-center justify-center space-x-2">
            <i className="ri-time-fill text-base"></i>
            <span className="font-bold text-sm">OFERTA LIMITADA:</span>
            <span className="font-mono text-lg font-bold">{formatTime(timeLeft)}</span>
          </div>
        </div>

        {/* Main Title - Split in two lines */}
        <h1 className="text-2xl sm:text-3xl font-black text-red-600 mb-1 leading-tight px-2">
          TRADING AUTOMÁTICO
        </h1>
        
        <h2 className="text-2xl sm:text-3xl font-black text-red-600 mb-3 px-2">
          SEÑALES GRATIS
        </h2>

        {/* Profile Image */}
        <div className="mb-2 flex justify-center">
          <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden shadow-xl border-4 border-purple-600">
            <img 
              src="https://static.readdy.ai/image/84eba62c088a7aa14bc47d978bcc6dc1/c8fdcb6423d681834f8c391d4767b618.jpeg"
              alt="Trading"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Top Telegram CTA Button */}
        <div className="mb-3 px-2">
          <button
            onClick={handleTelegramClick}
            className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-2 px-4 rounded-full text-sm sm:text-base transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer w-full sm:w-auto animate-pulse hover:animate-none"
          >
            <span className="flex items-center justify-center gap-2">
              <i className="ri-telegram-fill text-lg"></i>
              <span>HAZ CLIC PARA UNIRTE GRATIS</span>
            </span>
          </button>
        </div>

        {/* Main Message - Redesigned */}
        <div className="mb-3 px-2">
          <div className="bg-white rounded-xl shadow-2xl p-4 border-2 border-purple-200">
            
            {/* No Courses Statement */}
            <div className="bg-gradient-to-r from-red-50 to-red-100 rounded-lg p-2.5 mb-3 border-l-4 border-red-600">
              <p className="text-sm sm:text-base font-black text-red-700 flex items-center justify-center gap-2">
                <i className="ri-close-circle-fill text-base"></i>
                <span className="break-words">NO TE VOY A VENDER CURSOS</span>
              </p>
            </div>

            {/* What You Get */}
            <div className="space-y-2 mb-3">
              <div className="flex items-start gap-2 text-left">
                <i className="ri-check-double-fill text-green-600 text-base mt-0.5 flex-shrink-0"></i>
                <p className="text-sm font-bold text-gray-800 break-words">
                  <span className="text-purple-700">Copia mis señales</span> en tiempo real
                </p>
              </div>
              
              <div className="flex items-start gap-2 text-left">
                <i className="ri-check-double-fill text-green-600 text-base mt-0.5 flex-shrink-0"></i>
                <p className="text-sm font-bold text-gray-800 break-words">
                  Acceso a mi <span className="text-purple-700">algoritmo automático</span>
                </p>
              </div>
              
              <div className="flex items-start gap-2 text-left">
                <i className="ri-check-double-fill text-green-600 text-base mt-0.5 flex-shrink-0"></i>
                <p className="text-sm font-bold text-gray-800 break-words">
                  <span className="text-green-600 font-black">100% GRATIS</span> - Sin pagos ocultos
                </p>
              </div>
            </div>

            {/* Accuracy Badge */}
            <div className="bg-gradient-to-r from-purple-600 to-purple-700 rounded-lg p-2.5 shadow-lg">
              <div className="flex items-center justify-center gap-2">
                <i className="ri-trophy-fill text-yellow-300 text-lg"></i>
                <p className="text-white font-black text-sm whitespace-nowrap">
                  Precisión del 90-95% de efectividad
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* CTA Button */}
        <div className="mb-2 px-2">
          <button
            onClick={handleTelegramClick}
            className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 text-white font-bold py-3 px-6 rounded-full text-lg sm:text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-normal sm:whitespace-nowrap cursor-pointer animate-pulse hover:animate-none w-full sm:w-auto break-words"
          >
            <span className="flex items-center justify-center flex-wrap sm:flex-nowrap gap-2">
              <i className="ri-telegram-fill text-2xl"></i>
              <span className="break-words">ACCESO GRATIS AHORA</span>
            </span>
          </button>
        </div>

        {/* Benefits */}
        <div className="px-2">
          <p className="text-sm sm:text-base font-bold text-purple-600 break-words">
            ✅ Genera $500 por semana mientras duermes
          </p>
        </div>

      </div>
    </div>
  );
}
